import { createFileRoute } from '@tanstack/react-router'
import { FimConfig } from 'pages/fim/FimConfig'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const fimConfigSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string().optional(),
  tab: z.enum(['sources', 'inspect', 'fusion', 'output']).optional(),
  list: z.string().optional(),
})

const RouteComponent = () => {
  const search = Route.useSearch()
  return (
    <FimConfig
      siteID={search[SEARCH_PARAM_SITE_ID]}
      tab={search.tab}
      listId={search.list}
    />
  )
}

export const Route = createFileRoute('/fim/')({
  component: RouteComponent,
  validateSearch: fimConfigSearchParams,
  staticData: {
    title: 'FIM Config',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
